module.exports = __webpack_public_path__ + "static/media/sgd-8.3d6b8979.png";